import { B as BigValueTextMode, P as PercentChangeColorMode, a as BigValueJustifyMode, b as BigValueGraphMode, c as BigValueColorMode } from '../../../../../index-B0HfjrH_.js';

"use strict";
const pluginVersion = "12.2.1";
const defaultOptions = {
  colorMode: BigValueColorMode.Value,
  graphMode: BigValueGraphMode.Area,
  justifyMode: BigValueJustifyMode.Auto,
  percentChangeColorMode: PercentChangeColorMode.Standard,
  showPercentChange: false,
  textMode: BigValueTextMode.Auto,
  wideLayout: true
};

export { defaultOptions, pluginVersion };
